import { PropsWithChildren, ReactElement } from 'react';
import { Header } from './Header';
export const SimpleHeaderLayout = (props: PropsWithChildren) => {
  const {
    children
  } = props;
  return <>
      <Header isHideMenu={true} data-sentry-element="Header" data-sentry-source-file="SimpleHeaderLayout.tsx" />
      {children}
    </>;
};
export const getSimpleHeaderLayout = (page: ReactElement) => {
  return <SimpleHeaderLayout data-sentry-element="SimpleHeaderLayout" data-sentry-component="getSimpleHeaderLayout" data-sentry-source-file="SimpleHeaderLayout.tsx">{page}</SimpleHeaderLayout>;
};